import { queryOps } from "./Query";

export class QuerySegment {
  op: queryOps;

  constructor(querySegment: any) {
    this.op = querySegment?.op;
  }

  toAPIQuery() {
    return { op: this.op };
  }
}